import React from 'react'
import { SpeedInsights } from "@vercel/speed-insights/react"
import ReactDOM from 'react-dom/client'
import { AuthProvider } from './contexts/AuthContext'
import { FavoritesProvider } from './contexts/FavoritesContext'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <FavoritesProvider>
        <App />
        <SpeedInsights />
      </FavoritesProvider>
    </AuthProvider>
  </React.StrictMode>,
)
